export const DEFAULT_SORT_KEY = 'recommended';
export const EMPTY_ARRAY = [];
export const EMPTY_OBJECT = {};
export const EMPTY_FUNCTION = () => undefined;
